exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr[data-v-26860d65]:last-child{border-bottom:1px solid #dee2e6}.city-plan[data-v-26860d65]{height:25px;position:absolute;top:0;width:100%;margin-top:0;background:#79b8f2;display:block;margin-left:-10px;margin-right:-10px}", ""]);

// exports
